<template>
  <div class="video-container">
    <video
      class="video"
      id="videoContext"
      controls
      :src="src"
      :poster="poster"
      @play="playVideo"
      @loadeddata="onLoadedMetadata">
      <div class="play-button" v-if="videoLoaded && !playing">
        <div class="play-button-box" bindtap="playVideo" data-type="custom">
          <div class="iconfont icon-play"></div>
        </div>
        <div class="video-duration" v-if="videoLoaded && !playStatus">{{videoDuration}}</div>
      </div>
    </video>

  </div>
</template>

<style lang="less" scoped>
  .video-container{
    position: relative;
    width: 100%;
    height: 100%;
    .video{
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    .play-button{
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
    .play-button .play-button-box{
      display: flex;
      justify-content: center;
      align-items: center;
      width: 42px;
      height: 42px;
      background: linear-gradient(270deg, #2B7CEB 0%, #58BAEA 100%);
      box-shadow: 0px 4px 16px 0px rgba(33, 161, 235, 0.3);
      border-radius: 8rpx;
      color: #FFF;
      font-size: 32rpx;
    }
    .play-button .video-duration{
      position: absolute;
      bottom: -18px;
      left: 50%;
      transform: translateX(-50%);
      font-size: 12px;
      line-height: 12px;
      color: #FFF;
    }
  }
</style>

<script>
  import Utils from '@/untils/utils'
  export default {
    props: {
      src: String,
      poster: String,
    },
    data() {
      return {
        videoBk: null,
        playing: false,
        playStatus: null,
        videoLoaded: false,
        videoDuration: 0,
      }
    },
    mounted() {
      this.videoBk = document.getElementById('videoContext');
    },
    methods: {
      onLoadedMetadata(e) {
        // 元数据加载完成后显示播放按钮，并且解析视频时长
        this.videoLoaded = true;
        this.videoDuration = Utils.formatSeconds(this.videoBk.duration)
      },
      playVideo() {}
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Common/videoPlayer.vue